import { Injectable } from '@angular/core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';

export interface IBreadcrumb {
    label: string;
    url: any;
    data?: {};
    isListUrl?: boolean;
    clearCachedData?: boolean;
}

@Injectable()
export class BreadcrumbService {

    public routerList: IBreadcrumb[];

    constructor(
        private storage: SampleTrackingStorage) {
        this.routerList = [];
    }

    public AddRouterToBreadCrumb(currentRouteData: IBreadcrumb) {
        let index = -1;
        for (var data of this.routerList) {
            if (data.label === currentRouteData.label) {
                index = this.routerList.indexOf(data);
                break;
            }
        }
        if (index < 0) {
            this.routerList.push(currentRouteData);
            return;
        }
        this.routerList = this.routerList.slice(0, index + 1);
    }

    public get getRouterList() {
        return this.routerList;
    }

    public clear() {
        this.routerList = [];
        this.storage.clearGridData();
    }
}